var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._l((_vm.snackbarTimedList),function(tAlert,i){return _c('TimedAlert',{key:`${tAlert.msg}-${i}`,attrs:{"nbr":i,"snack":tAlert}})}),_vm._l((_vm.snackbarAlertList),function(alert,i){return _c('Alert',{key:`${alert.msg}-${i}`,attrs:{"nbr":_vm.snackbarTimedList.length + i,"snack":alert}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }